import { useTranslation } from 'react-i18next';
import JxtAvatar from '../JxtAvatar';
import { JxtAvatarSizeEnum } from '../JxtAvatar/types';
import { IJxtBookingAttendee, JxtBookingAttendeeTypeEnum } from './types';
import JxtBookingParticipationStatusIcon from '../JxtBookingParticipationStatusIcon';

const JxtBookingAttendee = ({
  name,
  picture,
  checkout,
  participationStatus,
  type = JxtBookingAttendeeTypeEnum.Default,
}: IJxtBookingAttendee) => {
  const { t } = useTranslation();
  const suffix =
    type === JxtBookingAttendeeTypeEnum.External
      ? ' (' + t('ext') + ')'
      : type === JxtBookingAttendeeTypeEnum.CurrentUser
        ? ' (' + t('you') + ')'
        : '';

  return (
    <div className="flex py-2 gap-2 items-center min-w-0">
      <JxtAvatar
        picture={picture}
        alt={t('avatar-of', { name })}
        size={JxtAvatarSizeEnum.XS}
        text={name[0]}
        className="shrink-0"
      />
      {/* Only the name is truncated, so the "(ext)" / "(you)" suffix stays visible */}
      <p className="flex min-w-0 text-body-m text-neutral-140" title={name + suffix}>
        <span className="truncate">{name}</span>
        {suffix && <span className="shrink-0 whitespace-pre">{suffix}</span>}
      </p>
      <div className="shrink-0">
        <JxtBookingParticipationStatusIcon icon={participationStatus} checkout={checkout} />
      </div>
    </div>
  );
};

export default JxtBookingAttendee;
